import dedent from "dedent";
let resetImported = false;
const markResetImported = () => {
  resetImported = true;
};
const ensureResetImported = () => {
  if (!resetImported) {
    throw new Error(dedent`
      Design system components imported before reset.

      Make sure to import the reset module before importing any components. 
      This ensures the CSS reset does not override the component styles. 
    
      e.g.

      import '@swift/design-system/css/reset'; // <-- Must be first
      import { ThemeProvider, Box } from '@swift/design-system';
    `);
  }
};
export {
  ensureResetImported,
  markResetImported
};
